var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"verify_result"},[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/success.png")}}),_c('h3',[_vm._v("已提交")]),_c('p',[_vm._v("银行将在1-2个工作日内审核，请关注账号信息变化")]),_c('footbtn',{attrs:{"btn-txt":"完成","is-on":_vm.isActive},on:{"next":_vm.next}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-693cd252","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Reverify_result.vue
// module id = null
// module chunks = 